import { render } from "./svg.vue?vue&type=template&id=2f0f4c76&scoped=true"
import script from "./svg.vue?vue&type=script&lang=js"
export * from "./svg.vue?vue&type=script&lang=js"

import "./svg.vue?vue&type=style&index=0&id=2f0f4c76&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2f0f4c76"

export default script